module.exports = __webpack_public_path__ + "static/media/face-in-clouds-svgrepo-com.c8bd3db9.svg";